/* =====================================================================
   Magnus Fridh — profilsidan
   ---------------------------------------------------------------------
   Samma beteende som design-mockups/magnus-fridh-d.html, men allt letar
   inne i .mfs i stället för i hela dokumentet. Sidan är en del av en
   butik nu: en query mot document hade fått tag i temats egna element.

   Varje sektion bär sin egen .mfs — det är vad som gör att de går att
   flytta, ta bort och lägga tillbaka i temaredigeraren. Därför finns det
   flera rötter, och letandet går igenom dem alla. Knappen i ett kort och
   formuläret den pekar på ligger i olika sektioner.

   js-anim sätts på varje .mfs, inte på <html>. CSS:en är skriven för det
   (.mfs.js-anim .rvl). Utan JS döljs ingenting — texten står synlig och
   sidan fungerar.
   ===================================================================== */
(function () {
  var rotter = [].slice.call(document.querySelectorAll('.mfs'));
  if (!rotter.length) return;

  /* Alla träffar i alla rötter, i dokumentordning. */
  function alla(sel) {
    var ut = [];
    rotter.forEach(function (r) {
      ut = ut.concat([].slice.call(r.querySelectorAll(sel)));
    });
    return ut;
  }
  function en(sel) { return alla(sel)[0] || null; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- Avtäckning ---------------------------------------------------
     Elementen är synliga från början. Först när vi vet att vi kan
     animera döljer vi dem (js-anim) och tänder dem igen när de kommer
     in i bild. Failsafe efter 2 s: har ingenting tänts är något fel på
     observern och då visas allt direkt. */
  var rvl = alla('.rvl');
  function visaAlla() {
    rvl.forEach(function (el) { el.classList.add('in'); });
  }

  if (!reduce.matches && 'IntersectionObserver' in window) {
    rotter.forEach(function (r) { r.classList.add('js-anim'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sibs = [].slice.call(e.target.parentNode.children).filter(function (n) {
          return n.classList.contains('rvl');
        });
        e.target.style.transitionDelay = (Math.min(sibs.indexOf(e.target), 4) * 95) + 'ms';
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    rvl.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      if (!en('.rvl.in')) { io.disconnect(); visaAlla(); }
    }, 2000);
  }

  /* Parallax låg här förut. Den är borta ur designen: heron är ett helt
     foto som går ut i kanterna och ska stå still. */

  /* --- Förfrågan ----------------------------------------------------
     Knappen i varje föreläsningskort tar med sig vilket spår det gäller
     ner till formuläret. Ingen ska behöva skriva samma sak två gånger. */
  var boka = en('#boka');
  var amne = en('#boka-amne');
  var namn = en('[name="contact[name]"]');
  var epost = en('[name="contact[email]"]');

  function tillBoka(fokus) {
    if (!boka) return;
    boka.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    if (fokus) setTimeout(function () { fokus.focus({ preventScroll: true }); }, 520);
  }

  alla('[data-amne]').forEach(function (k) {
    k.addEventListener('click', function (e) {
      e.preventDefault();
      var val = k.getAttribute('data-amne');
      if (amne) {
        [].forEach.call(amne.options, function (o) {
          if (o.textContent.trim() === val) amne.value = o.value;
        });
      }
      tillBoka(namn);
    });
  });

  /* --- E-postraden i heron ------------------------------------------
     Den postar ingenting. Den tar adressen med sig ner till förfrågan,
     fyller i e-postfältet där och lämnar markören i namnfältet — nästa
     sak att skriva. Ett andra riktigt formulär på samma sida hade
     behövt en egen kvittosida, och den som fyllt i det hade trott sig
     ha skickat en förfrågan som ingen läst.

     Utan JS körs ingenting av det här. Då gör webbläsaren det som står
     i form action: hoppar till #boka. Raden blir en länk i stället för
     en genväg, och ingen hamnar i en återvändsgränd. */
  alla('[data-mf-epost]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      /* Fyller bara i om adressen ser ut som en adress. Hälften av en
         inskriven e-post nere i förfrågan är värre än ett tomt fält —
         den ser ifylld ut och skickas vidare utan att någon läser om.
         Resan ner sker ändå: den som tryckt vill till formuläret. */
      var falt = f.querySelector('.falt');
      var val = falt ? falt.value.trim() : '';
      var duger = val && (!falt.checkValidity || falt.checkValidity());
      if (duger && epost) epost.value = val;
      tillBoka(duger ? namn : epost);
    });
  });
})();
